<template>
    <div>
      <TransitionRoot appear :show="isPROpen" @close="closePRModal" as="template">
        <Dialog as="div">
          <div class="fixed inset-0 z-50 overflow-y-auto">
            <div class="min-h-screen px-4 text-center">
              <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100"
                leave-to="opacity-0"
              >
                <DialogOverlay class="fixed inset-0 bg-black opacity-70" />
              </TransitionChild>
  
              <span class="inline-block h-screen align-middle" aria-hidden="true">
                &#8203;
              </span>
  
              <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0 scale-95"
                enter-to="opacity-100 scale-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100 scale-100"
                leave-to="opacity-0 scale-95"
              >
                <div
                  class="inline-block border w-full max-w-6xl p-6 my-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-2xl"
                >
                  <DialogTitle
                    as="h4"
                    :class=" isOk ? 'text-size font-medium leading-6 text-emerald-500' : 'text-size font-medium leading-6 text-gray-500'"
                  >
                    <div class="flex items-center space-x-0.5">
                      <svg class=" fill-emerald-600 w-5 h-5" id="Layer_1" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m10 10a3 3 0 0 0 0 6h4a3 3 0 0 0 0-6zm5 3a1 1 0 0 1 -1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1zm2 6a1 1 0 0 1 -1 1h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 1 1zm2.536-15.879-1.658-1.656a4.968 4.968 0 0 0 -3.535-1.465h-6.343a5.006 5.006 0 0 0 -5 5v14a5.006 5.006 0 0 0 5 5h8a5.006 5.006 0 0 0 5-5v-12.343a4.968 4.968 0 0 0 -1.464-3.536zm-1.414 1.414a3.1 3.1 0 0 1 .378.465h-2.5v-2.5a2.932 2.932 0 0 1 .464.377zm.878 14.465a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3-3v-14a3 3 0 0 1 3-3h6v3a2 2 0 0 0 2 2h3z"/></svg>
                      <span>Purchase Requisition</span>
                    </div>
                  </DialogTitle>
                  <div class="my-4 grid grid-cols-2 gap-4">
                    <div class="">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">Source of Funding <span class="font-bold text-red-500">*</span></label>
                      <div class="flex ">
                        <div class=" w-full">
                          <CustomDropDown
                            :elementId="'budgetSource'"
                            :url="'/budget-source/search'"
                            :persistedSelection="selectedBudgetSources"
                            :multipleSelection="true"
                            @selectedItems="(items) => {
                              selectedBudgetSources = items
                            }"
                            :display="{
                              id: 'id',
                              name: ['name']
                            }"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">is Donor Prior Approval Required <span class="font-bold text-red-500">*</span></label>
                      <div class="flex ">
                        <div class=" w-full">
                          <CustomDropDown
                            :elementId="'donorApproval'"
                            :url="'/choice/search'"
                            :persistedSelection="donorApproval"
                            :multipleSelection="true"
                            @selectedItems="(items) => {
                              donorApproval = items
                            }"
                            :display="{
                              id: 'id',
                              name: ['name']
                            }"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="space-y-0.5">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Budget Line <span class="font-bold text-red-500">*</span></label>
                      <input
                        v-model="budgetLine"
                        placeholder="Budget Line"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                    <div class="space-y-0.5">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">Budget Amount <span class="font-bold text-red-500">*</span></label>
                      <input
                        v-model="budgetAmount"
                        placeholder="Budget Amount"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                    <div class="">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">District <span class="font-bold text-red-500">*</span></label>
                      <div class="flex ">
                        <div class=" w-full">
                          <CustomDropDown
                            :elementId="'districtId'"
                            :url="'/district/search'"
                            :persistedSelection="districtName"
                            :multipleSelection="false"
                            @selectedItems="(items) => {
                              districtName = items
                            }"
                            :display="{
                              id: 'id',
                              name: ['name']
                            }"
                          />
                      </div>
                      </div>
                      </div>
                    <div class="space-y-0.5">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Specific Area/Region <span class="font-bold text-red-500">*</span></label>
                      <input
                        v-model="area"
                        placeholder="Specific Region/Area"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                    <div class="space-y-0.5">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">Specification of Goods/Services <span class="font-bold text-red-500">*</span></label>
                      <input
                        v-model="specification"
                        placeholder="Specification of Goods & Services"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                    <div class="space-y-0.5">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">Check In Date <span class="font-bold text-red-500">*</span></label>
                      <input
                        v-model="checkInDate"
                        placeholder="Check In Date"
                        type="date"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                    <div class="space-y-0.5">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">Check Out Date <span class="font-bold text-red-500">*</span></label>
                      <input
                        v-model="checkOutDate"
                        placeholder="Check In Date"
                        type="date"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                    <div class="space-y-0.5">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">No of Single Rooms <span class="font-bold text-red-500">*</span></label>
                      <input
                        v-model="singleRooms"
                        placeholder="No of Single Rooms Needed"
                        type="number"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                    <div class="space-y-0.5">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">No of Double Rooms <span class="font-bold text-red-500">*</span></label>
                      <input
                        v-model="doubleRooms"
                        type="number"
                        placeholder="No of Double Rooms Needed"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                    <div class="space-y-0.5">
                       <label for="email" class="block text-size-md font-medium text-gray-600 text-left">Conference Package <span @click="show=!show" class=" text-emerald-500 font-normal cursor-pointer">(click here for to see or close the package details)</span><span class="font-bold text-red-500">*</span></label>
                      <!-- the conference package details -->
                      <div :class="show ? 'absolute bg-white border shadow-2xl translate-x-10 p-4 text-size-md space-y-2' : 'hidden'">
                        <div>
                          <span>Conference Package Definitions</span>
                        </div>
                        <div>
                          <span>CP1	:	Conference Package 1 – Lunch only</span>
                        </div>
                        <div>
                          <span>CP2	:	Conference Package 2 – Tea & Lunch only</span>
                        </div>
                        <div>
                          <span>CP3	:	Conference Package 3 – 2 Teas, 2 waters & Lunch</span>
                        </div>
                        <div>
                          <span>CP4	:	Conference Package 4 – Accommodation (B&B) and Dinner</span>
                        </div>
                        <div>
                          <span>CP5	:	Conference Package 5 – Accommodation (B&B) only</span>
                        </div>
                      </div>
                      <!-- the packages -->
                      <div class="grid grid-cols-6">
                        <div class="items-center">
                          <label for="email" class="block text-size-md font-medium text-gray-600 text-left">CP1</label>
                          <input
                            v-model="confPackage"
                            type="checkbox"
                            value="CP1"
                            name="package1"
                            class="bg-gray-50 text-gray-600 border px-2 py-3 ml-1 border-gray-300 focus:outline-none"/>
                        </div>
                        <div class="items-center">
                          <label for="email" class="block text-size-md font-medium text-gray-600 text-left">CP2</label>
                          <input
                            v-model="confPackage2"
                            value="CP2"
                            placeholder="Confrerence Package"
                            type="checkbox"
                            name="package2"
                            class="text-size-md text-gray-600 border px-2 py-3 ml-1 border-gray-300 focus:outline-none"/>
                        </div>
                        <div class="items-center">
                          <label for="email" class="block text-size-md font-medium text-gray-600 text-left">CP3</label>
                          <input
                            v-model="confPackage3"
                            value="CP3"
                            placeholder="Confrerence Package"
                           type="checkbox"
                            name="package3"
                            class="text-size-md text-gray-600 border px-2 py-3 ml-1 border-gray-300 focus:outline-none"/>
                        </div>
                        <div class="flex-1 items-center">
                          <label for="email" class="block text-size-md font-medium text-gray-600 text-left">CP4</label>
                          <input
                            v-model="confPackage4"
                            value="CP4"
                            placeholder="Confrerence Package"
                            type="checkbox"
                            name="package4"
                            class="text-size-md text-gray-600 border px-2 py-3 ml-1 border-gray-300 focus:outline-none"/>
                        </div>
                        <div class="items-center">
                          <label for="email" class="block text-size-md font-medium text-gray-600 text-left">CP5</label>
                          <input
                            v-model="confPackage5"
                            value="CP5"
                            placeholder="Confrerence Package"
                            type="checkbox"
                            name="package5"
                            class="text-size-md text-gray-600 border px-2 py-3 ml-1 border-gray-300 focus:outline-none"/>
                        </div>
                        <div class="items-center flex-1">
                          <label for="email" class="block text-size-md font-medium text-gray-600 text-left">Hall Hire</label>
                          <input
                            v-model="hallHire"
                            value="Hall Hire"
                            placeholder="Confrerence Package"
                            type="checkbox"
                            name="package"
                            class="text-size-md text-gray-600 ml-4 border px-2 py-3 border-gray-300 focus:outline-none"/>
                        </div>
                      </div>
                    </div>
                    <div class="space-y-0.5">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">Quantity Per Participant <span class="font-bold text-red-500">*</span></label>
                      <input
                        v-model="Qparticipants"
                        type="number"
                        placeholder="Quantity Per Participant"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                    <div class="space-y-0.5">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">No of Participants <span class="font-bold text-red-500">*</span></label>
                      <input
                        v-model="noParticipants"
                        type="number"
                        placeholder="No of Participants"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                    <div class="space-y-0.5">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">No of Days Needed <span class="font-bold text-red-500">*</span></label>
                      <input
                        v-model="days"
                        type="number"
                        placeholder="No of Days Needed"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                    <!-- <div class="space-y-0.5">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">Delivery Time <span class="font-bold text-red-500">*</span></label>
                      <input
                        v-model="deliveryTime"
                        type="time"
                        placeholder="Reason for denying the request"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-600"/>
                    </div> -->
                    <div class="space-y-0.5">
                      <label for="email" class="block text-size-md font-medium text-gray-600 text-left">Delivery Date <span class="font-bold text-red-500">*</span></label>
                      <input
                        v-model="deliveryDate"
                        type="date"
                        placeholder="Reason for denying the request"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
  
                  <div class="mt-2 flex justify-center space-x-1">
                    <button
                      type="button"
                      class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                              border-transparent hover:bg-emerald-500 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                              focus-visible:ring-offset-2 focus-visible:ring-white"
                      @click="closePRModal()"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                              border-transparent hover:bg-emerald-500 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                              focus-visible:ring-offset-2 focus-visible:ring-white"
                      @click="submit()"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </TransitionRoot>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue'
  import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from '@headlessui/vue'
  import CustomDropDown from './CustomDropDown.vue'
  import { mapState } from 'vuex'
  
  export default {
    computed: {
      ...mapState([
        'editPrsOnly',
        'memo',
      ])
    },
    components: {
      TransitionRoot,
      TransitionChild,
      Dialog,
      DialogOverlay,
      CustomDropDown
      // DialogTitle
    },
    setup () {
      const isPROpen = ref(false)
      return {
        isPROpen,
        closePRModal () {
          isPROpen.value = false
        },
        openPRModal () {
          isPROpen.value = true
        }
      }
    },
    watch: {
      editIndex () {
        if (this.editIndex !== -1) {
          this.loadVuexData()
        }
      }
    },
    name: 'message-modal',
    props: {
    },
    mounted () {
      // set the destination exception
      if (this.memo !== null && this.memo.destination !== undefined  && this.memo.destination.name !== undefined) {
        this.except = this.memo.destination.allData.name
      }

      // console.log(this.editIndex, 'mountedxxx')
      if (this.editIndex !== -1) {
        this.loadVuexData()
      }
      // detect outside clicks
      this.outsideClicks()
    },
    data: () => {
      return {
        donorApproval: {},
        selectedBudgetSources: {},
        show: false,
        editIndex: -1,
        except: '',
        specification: '',
        budgetLine: '',
        budgetAmount: 0,
        districtName: {},
        area: '',
        checkInDate: '',
        checkOutDate: '',
        singleRooms: 0,
        doubleRooms: 0,
        confPackage: '',
        confPackage2: '',
        confPackage3: '',
        confPackage4: '',
        confPackage5: '',
        hallHire: '',
        Qparticipants: '',
        noParticipants: 0,
        days: 0,
        deliveryTime: '',
        deliveryDate: '',
        hasConferencing: false,
        hasAccommodation: false
      }
    },
    methods: {
      // detect outside clicks
      outsideClicks () {
        document.addEventListener('click', (event) => {
          const menu = this.$refs.menu
          if (menu !== null && menu !== undefined && menu && !menu.contains(event.target)) {
            this.show = false
          }
        })
      },
      // sets the edit index
      setEditIndex (index) {
        this.editIndex = index
      },
      // loads the stored vuex data
      loadVuexData () {
        if (this.editPrsOnly[this.editIndex] !== null) {
          // console.log(this.editIndex, '<<<<<<<<<<<<<<<<')
          if (this.prsOnly[this.editIndex].donorApproval !== undefined) {
            this.donorApproval = this.prsOnly[this.editIndex].donorApproval
          }
          if (this.editPrsOnly[this.editIndex].budgetLine !== undefined) {
            this.selectedBudgetSources = this.editPrsOnly[this.editIndex].budgetSources
          }
          if (this.editPrsOnly[this.editIndex].budgetLine !== undefined) {
            this.budgetLine = this.editPrsOnly[this.editIndex].budgetLine
          }
          if (this.editPrsOnly[this.editIndex].budgetAmount !== undefined) {
            this.budgetAmount = this.editPrsOnly[this.editIndex].budgetAmount
          }
          if (this.editPrsOnly[this.editIndex].districtName.id !== undefined) {
            this.districtName = { id: this.editPrsOnly[this.editIndex].districtName.id, name: this.editPrsOnly[this.editIndex].districtName.name }
          }
          if (this.editPrsOnly[this.editIndex].area !== undefined) {
            this.area = this.editPrsOnly[this.editIndex].area
          }
          if (this.editPrsOnly[this.editIndex].specification !== undefined) {
            this.specification = this.editPrsOnly[this.editIndex].specification
          }
          if (this.editPrsOnly[this.editIndex].checkInDate !== undefined) {
            this.checkInDate = this.editPrsOnly[this.editIndex].checkInDate
          }
          if (this.editPrsOnly[this.editIndex].checkOutDate !== undefined) {
            this.checkOutDate = this.editPrsOnly[this.editIndex].checkOutDate
          }
          if (this.editPrsOnly[this.editIndex].singleRooms !== undefined) {
            this.singleRooms = this.editPrsOnly[this.editIndex].singleRooms
          }
          if (this.editPrsOnly[this.editIndex].doubleRooms !== undefined) {
            this.doubleRooms = this.editPrsOnly[this.editIndex].doubleRooms
          }
          if (this.editPrsOnly[this.editIndex].deliveryDate !== undefined) {
            this.deliveryDate = this.editPrsOnly[this.editIndex].deliveryDate
          }

          if (this.editPrsOnly[this.editIndex].confPackage !== undefined) {
            this.confPackage = this.editPrsOnly[this.editIndex].confPackage
          }
          if (this.editPrsOnly[this.editIndex].confPackage2 !== undefined) {
            this.confPackage2 = this.editPrsOnly[this.editIndex].confPackage2
          }
          if (this.editPrsOnly[this.editIndex].confPackage3 !== undefined) {
            this.confPackage3 = this.editPrsOnly[this.editIndex].confPackage3
          }
          if (this.editPrsOnly[this.editIndex].confPackage4 !== undefined) {
            this.confPackage4 = this.editPrsOnly[this.editIndex].confPackage4
          }
          if (this.editPrsOnly[this.editIndex].confPackage !== undefined) {
            this.confPackage5 = this.editPrsOnly[this.editIndex].confPackage5
          }
          if (this.editPrsOnly[this.editIndex].hallHire !== undefined) {
            this.hallHire = this.editPrsOnly[this.editIndex].hallHire
          }

          if (this.editPrsOnly[this.editIndex].Qparticipants !== undefined) {
            this.Qparticipants = this.editPrsOnly[this.editIndex].Qparticipants
          }
          if (this.editPrsOnly[this.editIndex].noParticipants !== undefined) {
            this.noParticipants = this.editPrsOnly[this.editIndex].noParticipants
          }
          if (this.editPrsOnly[this.editIndex].days !== undefined) {
            this.days = this.editPrsOnly[this.editIndex].days
          }
          if (this.editPrsOnly[this.editIndex].deliveryTime !== undefined) {
            this.deliveryTime = this.editPrsOnly[this.editIndex].deliveryTime
          }
        }
      },
      submit () {
        // only save it if some fields are filled
        if (Array.isArray(this.selectedBudgetSources) && this.selectedBudgetSources.length > 0 &&  this.budgetLine !== undefined && this.budgetLine !== '' && !isNaN(this.budgetAmount) &&this.districtName.id !== undefined && this.area.trim() !== '' && this.specification.trim() !== '') {
          // save the pr & close the modal
          this.savePR()
          // close the modal
          this.closePRModal()
        }
      },
      savePR () {
        const prData = {
          donorApproval: this.donorApproval,
          budgetSources: this.selectedBudgetSources,
          specification: this.specification,
          budgetLine: this.budgetLine,
          budgetAmount: this.budgetAmount,
          districtName: this.districtName,
          area: this.area,
          checkInDate: this.checkInDate,
          checkOutDate: this.checkOutDate,
          singleRooms: this.singleRooms,
          doubleRooms: this.doubleRooms,
          confPackage: this.confPackage,
          confPackage2: this.confPackage2,
          confPackage3: this.confPackage3,
          confPackage4: this.confPackage4,
          confPackage5: this.confPackage5,
          hallHire: this.hallHire,
          Qparticipants: this.Qparticipants,
          noParticipants: this.noParticipants,
          days: this.days,
          deliveryTime: this.deliveryTime,
          deliveryDate: this.deliveryDate
        }
        
        // create the 
        if (this.editIndex == -1) {
          this.$store.commit('mutateEditPRsOnly', prData)
        } else {
          const data = {
            index: this.editIndex,
            data: prData
          }
          this.$store.commit('mutateAtIndexEditPRsOnly', data)
        }
        this.$emit('onSubmit', prData)
        console.log('saved')
      },
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style >
  </style>
  